export interface BirthLocation {
    code: string;
    description: string;
    isForeignCountry: boolean;
    province: string;
}

export interface RecordType {
    Name: string;
}

export interface Account {
    RecordType: RecordType;
    Name?: any;
    Company_Name__c?: any;
    Type_of_Business__c?: any;
    NE__Name__c: string;
    NE__Surname__c: string;
    Country_of_Service_Code__c: string;
    Region__c?: string;
    Region_Code__c: string;
    NE__Fiscal_code__c?: any;
    Fiscal_Code_Valid__c?: boolean;
    Community_VAT__c?: any;
    FiscalCodeEU?: any;
    SubscriberMobilePhone__c: string;
    BillingCountryCode?: any;
    BillingStreet?: any;
    BillingCity?: any;
    BillingStateCode?: any;
    BillingPostalCode?: any;
    Dealer_CompanyLegalAddress__CountryCode__s: any;
    Dealer_CompanyLegalAddress__Street__s: any;
    Dealer_CompanyLegalAddress__City__s: any;
    Dealer_CompanyLegalAddress__StateCode__s: any;
    Dealer_CompanyLegalAddress__PostalCode__s: any;
    Billing_Email__c?: any;
    CUFE__c?: any;
    Notification_Default_Language_Code__c: string;
    Identification_Question1__c: string;
    Identification_Answer1__c: string;
    Identification_Question2__c: string;
    Identification_Answer2__c: string;
    Identification_Question3__c?: any;
    Identification_Answer3__c?: any;
}

export interface User {
    Id: string;
    AccountId: string;
    Role__c: string;
    VA_IAM_Account_Id__c: string;
    Email: string;
    gender: string;
    WithinItaly: string;
    birth_date: string;
    birth_place_code: string;
    Birthplace__c: string;
    Birthdate: string;
    Gender__c: string;
    MobilePhone: string;
    FirstName: string;
    LastName: string;
    Account: Account;
    Phone: any;
}

export class User {
    Id: string = this.Id;
    AccountId: string = this.AccountId;
    Role__c: string = this.Role__c;
    VA_IAM_Account_Id__c: string = this.VA_IAM_Account_Id__c;
    Email: string = this.Email;
    MobilePhone: string = this.MobilePhone;
    FirstName: string = this.FirstName;
    LastName: string = this.LastName;
    Account: Account = this.Account;
    Birthplace__c: string = this.Birthplace__c;
    Birthdate: string = this.Birthdate;
    Gender__c: string = this.Gender__c;

    constructor(
        obj: User
    ) {
        this.Id = obj.Id,
            this.AccountId = obj.AccountId,
            this.Role__c = obj.Role__c,
            this.VA_IAM_Account_Id__c = obj.VA_IAM_Account_Id__c,
            this.Email = obj.Email,
            this.MobilePhone = obj.MobilePhone,
            this.FirstName = obj.FirstName,
            this.LastName = obj.LastName
        this.Account = obj.Account
        this.Birthplace__c = obj.Birthplace__c;
        this.Birthdate = obj.Birthdate;
        this.Gender__c = obj.Gender__c;
    }
}

export const userAddress: any = {
    "default": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s", visible: true, mandatory: false },
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "none": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: false, mandatory: false },
        billingStreet: { visible: false, mandatory: false },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: false, mandatory: false },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: false, mandatory: false},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "GB": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "GI": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "IE": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: false},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "MT": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "IT": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: true, mandatory: true, autocomplete: "getProvinceLevelTwo" }
    },
    "SM": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true, autocomplete: "getCitySM" },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: true, mandatory: false, autocomplete: "getProvinceLevelTwo" }
    },
    "VA": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: true, mandatory: false, autocomplete: "getProvinceLevelTwo" }
    },
    "DE": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "AT": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "ES": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: true, mandatory: true, autocomplete: "getProvinceLevelTwo" }
    },
    "AD": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: true, mandatory: true, autocomplete: "getProvinceLevelTwo" }
    },
    "FR": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "MC": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "BE": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "NL": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "LU": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "LT": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "CZ": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "SK": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: false, mandatory: false }
    },
    "PL": {
        billingCountry: {label: "Dealer_CompanyLegalAddress__CountryCode__s", visible: true, mandatory: true },
        billingStreet: { visible: true, mandatory: true },
        billingCity: { label: "Dealer_CompanyLegalAddress__City__s", visible: true, mandatory: true },
        billingPostalCode: { label: "Dealer_CompanyLegalAddress__PostalCode__s",visible: true, mandatory: true},
        billingStateCode: { label: "Dealer_CompanyLegalAddress__StateCode__s", visible: true, mandatory: true, autocomplete: "getProvincePoland" }
    }
}

export const userOptionalAddress: any = {
    "default": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode", visible: true, mandatory: false },
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "none": {
        additionalCountry: { label: "BillingCountryCode", visible: false, mandatory: false },
        additionalStreet: { visible: false, mandatory: false },
        additionalCity: { label: "BillingCity", visible: false, mandatory: false },
        additionalPostalCode: { label: "BillingPostalCode",visible: false, mandatory: false},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "GB": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "GI": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "IE": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "MT": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "IT": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: true, mandatory: true, autocomplete: "getProvinceLevelTwo" }
    },
    "SM": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true, autocomplete: "getCitySM" },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true },
        additionalStateCode: { label: "BillingStateCode", visible: true, mandatory: false, autocomplete: "getProvinceLevelTwo" }
    },
    "VA": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: true, mandatory: false, autocomplete: "getProvinceLevelTwo" }
    },
    "DE": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "AT": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "ES": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: true, mandatory: true, autocomplete: "getProvinceLevelTwo" }
    },
    "AD": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: true, mandatory: true, autocomplete: "getProvinceLevelTwo" }
    },
    "FR": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "MC": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "BE": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "NL": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "LU": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "LT": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "CZ": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false } 
    },
    "SK": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: false, mandatory: false }
    },
    "PL": {
        additionalCountry: { label: "BillingCountryCode", visible: true, mandatory: true },
        additionalStreet: { visible: true, mandatory: true },
        additionalCity: { label: "BillingCity", visible: true, mandatory: true },
        additionalPostalCode: { label: "BillingPostalCode",visible: true, mandatory: true},
        additionalStateCode: { label: "BillingStateCode", visible: true, mandatory: true, autocomplete: "getProvincePoland" }
    }
}

export const polandStateCodes: any = {
    "dolnośląskie": "DS",
    "kujawsko-pomorskie": "KP",
    "lubelskie": "LU",
    "lubuskie": "LB",
    "łódzkie": "LD",
    "małopolskie": "MA",
    "mazowieckie": "MZ",
    "opolskie": "OP",
    "podkarpackie": "PK",
    "podlaskie": "PD",
    "pomorskie": "PM",
    "śląskie": "SL",
    "świętokrzyskie": "SK",
    "warmińsko-mazurskie": "WN",
    "wielkopolskie": "WP",
    "zachodniopomorskie": "ZP"
  }  

export const userCountry: any = {
    // Great Britain
    "GB": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^[a-zA-Z0-9]{0,20}$', length: 20 },
            Type_of_Business__c: { visible: true, mandatory: true },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Gibraltar -> GB
    "GI": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: true, mandatory: true },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Ireland -> GB
    "IE": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: "^[a-zA-Z0-9]{0,20}$", length: 20 },
            Type_of_Business__c: { visible: true, mandatory: true },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Malta -> GB
    "MT": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^[a-zA-Z0-9]{0,20}$', length: 20 },
            Type_of_Business__c: { visible: true, mandatory: true },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Italy
    "IT": {
        "Consumer": {
            gender: { visible: true, mandatory: true },
            birth_date: { visible: true, mandatory: true },
            birth_place_code: { visible: true, mandatory: true },
            WithinItaly: { visible: true, mandatory: true },
            NE__Fiscal_code__c: { visible: true, mandatory: true, validationEnabled: true, pattern: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{1}$', length: 16 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: true, mandatory: true },
            birth_date: { visible: true, mandatory: true },
            birth_place_code: { visible: true, mandatory: true },
            WithinItaly: { visible: true, mandatory: true },
            NE__Fiscal_code__c: { visible: true, mandatory: true, validationEnabled: true, pattern: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{1}$', length: 16 },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: true, mandatory: false, pattern: '^[0-9a-zA-Z]{7}$', length: 7 },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        },
        "Large Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: true, mandatory: true, pattern: '^[0-9a-zA-Z]{7}$', length: 7 },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // San Marino -> IT
    "SM": {
        "Consumer": {
            gender: { visible: true, mandatory: true },
            birth_date: { visible: true, mandatory: true },
            birth_place_code: { visible: true, mandatory: true },
            WithinItaly: { visible: true, mandatory: true },
            NE__Fiscal_code__c: { visible: true, mandatory: true, validationEnabled: true, pattern: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{1}$', length: 16 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: true, mandatory: true },
            birth_date: { visible: true, mandatory: true },
            birth_place_code: { visible: true, mandatory: true },
            WithinItaly: { visible: true, mandatory: true },
            NE__Fiscal_code__c: { visible: true, mandatory: true, validationEnabled: true, pattern: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{1}$', length: 16 },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: true, mandatory: false, pattern: '^[0-9a-zA-Z]{7}$', length: 7 },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        },
        "Large Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: true, mandatory: true, pattern: '^[0-9a-zA-Z]{7}$', length: 7 },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Vatican City -> IT
    "VA": {
        "Consumer": {
            gender: { visible: true, mandatory: true },
            birth_date: { visible: true, mandatory: true },
            birth_place_code: { visible: true, mandatory: true },
            WithinItaly: { visible: true, mandatory: true },
            NE__Fiscal_code__c: { visible: true, mandatory: true, validationEnabled: true, pattern: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{1}$', length: 16 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: true, mandatory: true },
            birth_date: { visible: true, mandatory: true },
            birth_place_code: { visible: true, mandatory: true },
            WithinItaly: { visible: true, mandatory: true },
            NE__Fiscal_code__c: { visible: true, mandatory: true, validationEnabled: true, pattern: '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z]{1}[0-9]{2}[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{1}$', length: 16 },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: true, mandatory: false, pattern: '^[0-9a-zA-Z]{7}$', length: 7 },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        },
        "Large Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^[0-9]{11}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: true, mandatory: true, pattern: '^[0-9a-zA-Z]{7}$', length: 7 },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Germany
    "DE": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{10,11}$', length: 11 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Large Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{10,11}$', length: 11 },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(DE)?[0-9]{9}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Austria -> Germany
    "AT": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{10,11}$', length: 11 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Large Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{10,11}$', length: 11 },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(ATU)?[0-9]{8}$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Spain
    "ES": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: true, pattern: '^[a-zA-Z0-9][0-9]{7}[a-zA-Z]$', length: 9 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^(ES)?[0-9a-zA-Z][0-9]{7}[0-9a-zA-Z]$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Andorra -> Spain
    "AD": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: true, pattern: '^[a-zA-Z0-9][0-9]{7}[a-zA-Z]$', length: 9 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^(ES)?[0-9a-zA-Z][0-9]{7}[0-9a-zA-Z]$', length: 11 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // France
    "FR": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^(FR)?[0-9a-zA-Z]{2}[0-9]{9}$', length: 13 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Monaco -> France
    "MC": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: false, mandatory: false },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^(FR)?[0-9a-zA-Z]{2}[0-9]{9}$', length: 13 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Belgium -> BeNeLux
    "BE": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(BE)?[0-9]{10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(BE)?[0-9]{10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Netherlands -> BeNeLux
    "NL": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(NL)?[0-9]{9}B[0-9]{2}$', length: 14 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(NL)?[0-9]{9}B[0-9]{2}$', length: 14 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Luxemburg -> BeNeLux
    "LU": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(LU)?[0-9]{8}$', length: 10 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(LU)?[0-9]{8}$', length: 10 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        },
    },
    // Lithuania
    "LT": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(LT)[0-9]{8,10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Czech Republic
    "CZ": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{8}$', length: 8 },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(CZ)[0-9]{8,10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{8}$', length: 8 },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(CZ)[0-9]{8,10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Slovakia -> Czech Republic
    "SK": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{8}$', length: 8 },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(SK)[0-9]{8,10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: false, pattern: '^[0-9]{8}$', length: 8 },
            Community_VAT__c: { visible: true, mandatory: false, pattern: '^(SK)[0-9]{8,10}$', length: 12 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: false, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    },
    // Poland
    "PL": {
        "Consumer": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: true, mandatory: true, pattern: '^[0-9]{10,11}$', length: 11 },
            Community_VAT__c: { visible: false, mandatory: false },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: false, mandatory: false },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: false, mandatory: false }
        },
        "Small Business": {
            gender: { visible: false, mandatory: false },
            birth_date: { visible: false, mandatory: false },
            birth_place_code: { visible: false, mandatory: false },
            WithinItaly: { visible: false, mandatory: false },
            NE__Fiscal_code__c: { visible: false, mandatory: false },
            Community_VAT__c: { visible: true, mandatory: true, pattern: '^(PL)?[0-9]{10}$|^[0-9]{9}$|^[0-9]{14}$', length: 14 },
            Type_of_Business__c: { visible: false, mandatory: false },
            companyName: { visible: true, mandatory: true },
            CUFE__c: { visible: false, mandatory: false },
            Billing_Email__c: { visible: true, mandatory: true, email: true },
            additionalAutocomplete: { visible: true, mandatory: false }
        }
    }
}
